import { AlignmentEnumAlignment as V2ImageAlignment, ImageFit as V2ImageFit, ImagePosition as V2ImagePosition } from '@wix/ambassador-forms-v4-form/types';
import { ImageAlignment, ImageFit, ImagePosition } from '../types';
export const toV1ImagePlacement = (imagePosition)=>imagePosition === V2ImagePosition.BELOW ? ImagePosition.BOTTOM : ImagePosition.TOP;
export const toV2ImagePosition = (imagePlacement)=>imagePlacement === ImagePosition.BOTTOM ? V2ImagePosition.BELOW : V2ImagePosition.ABOVE;
export const toV1ImageFit = (imageFit)=>imageFit === V2ImageFit.CONTAIN ? ImageFit.CONTAIN : ImageFit.COVER;
export const toV2ImageFit = (imageFit)=>imageFit === ImageFit.CONTAIN ? V2ImageFit.CONTAIN : V2ImageFit.COVER;
export const toV1ImageAlignment = (alignment)=>{
    if (alignment === V2ImageAlignment.LEFT) {
        return ImageAlignment.LEFT;
    }
    if (alignment === V2ImageAlignment.RIGHT) {
        return ImageAlignment.RIGHT;
    }
    return ImageAlignment.CENTER;
};
export const toV2ImageAlignment = (alignment)=>{
    if (alignment === ImageAlignment.LEFT) {
        return V2ImageAlignment.LEFT;
    }
    if (alignment === ImageAlignment.RIGHT) {
        return V2ImageAlignment.RIGHT;
    }
    return V2ImageAlignment.CENTER;
};
export const toV2LabelMedia = (image)=>image ? {
        image: {
            id: image.id,
            width: image.width,
            height: image.height,
            altText: image.altText
        }
    } : undefined;
export const fromV2LabelMedia = (media)=>{
    const image = media?.image;
    if (!image?.id) {
        return undefined;
    }
    return {
        id: image.id,
        width: image.width ?? 0,
        height: image.height ?? 0,
        altText: image.altText ?? undefined
    };
};
export function createFieldLabelMediaProperties(view) {
    if (!view.questionImage) {
        return {};
    }
    const mediaSettings = toFieldLabelMediaSettings(view);
    return {
        media: {
            ...view.questionImage,
            ...view.questionImageAltText !== undefined && {
                altText: view.questionImageAltText
            }
        },
        ...mediaSettings && {
            mediaSettings
        }
    };
}
function toFieldLabelMediaSettings(view) {
    const mediaSettings = {
        ...view.questionImagePlacement && {
            imagePosition: view.questionImagePlacement
        },
        ...view.questionImageResize && {
            imageFit: view.questionImageResize
        },
        ...view.questionImageAlignment && {
            imageAlignment: view.questionImageAlignment
        }
    };
    return Object.keys(mediaSettings).length ? mediaSettings : undefined;
}

//# sourceMappingURL=label-media.js.map